'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { SlArrowRight } from 'react-icons/sl'
import classNames from 'classnames'
import { makeCategoryHref } from '@/lib/makeCategoryHref'
import { capitalizeFirst } from '@/utils/capitalize'

interface BCProps {
    categoriesbc?: any
}

const Breadcrumbs = ({ categoriesbc }: BCProps) => {
    const pathname = usePathname()
    if (pathname === '/') return null

    const breadcrumbs = [
        { label: 'Главная', href: '/', isLast: false },
        { label: 'Каталог', href: '/catalog', isLast: false },
    ]

        if (pathname === '/catalog/all') {
        breadcrumbs.push({
            label: 'Все товары',
            href: '/catalog/all',
            isLast: true, // последняя крошка
        })
    }

    if (categoriesbc?.parents?.length > 0) {
        categoriesbc.parents.forEach((item) => {
            breadcrumbs.push({
                label: item.text,
                href: makeCategoryHref(item.url),
                isLast: false,
            })
        })
    }

    if (categoriesbc?.text) {
        breadcrumbs.push({
            label: categoriesbc.text,
            href: makeCategoryHref(categoriesbc.url),
            isLast: false,
        })
    }

    const breadcrumbsLast = breadcrumbs.map((item, index) => ({
        ...item,
        isLast: index === breadcrumbs.length - 1,
    }))

    return (
        <nav className="my-6 lg:block">
            <ol className="flex items-center gap-2 flex-wrap md:gap-4 text-[8px] md:text-xs">
                {breadcrumbsLast?.map((item, index) => (
                    <li key={index} className="flex items-center gap-4">
                        <div
                            className={classNames(
                                'text-[13px] font-normal leading-[16px] tracking-[0.25px]',
                                {
                                    'text-[#8f8f8f]': item.isLast,
                                    'text-[#414141] hover:underline cursor-pointer':
                                        !item.isLast,
                                },
                            )}
                        >
                            {item.isLast ? (
                                capitalizeFirst(item.label)
                            ) : (
                                <Link href={item.href}>{capitalizeFirst(item.label)}</Link>
                            )}
                        </div>
                        {!item.isLast && <SlArrowRight size={12} />}
                    </li>
                ))}
            </ol>
        </nav>
    )
}

export default Breadcrumbs
